import { useTranslation } from 'react-i18next'
import { Select } from '@fs/zion-ui'
import PropTypes from 'prop-types'
import React from 'react'

/**
 * Used on artifact pages to filter artifacts by their category
 */
const StatusFilter = ({ value, onChange }) => {
  const [t] = useTranslation()
  return (
    <Select
      hidePlaceholder
      autoWidth
      label={t('status', 'Status')}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      name="statusFilter"
      options={[
        {
          value: 'default',
          label: t('artifacts.default', 'Default'),
        },
        {
          value: 'tombstoned',
          label: t('artifacts.tombstoned', 'Tombstoned'),
        },
        {
          value: 'approved',
          label: t('artifacts.approved', 'Approved'),
        },
        {
          value: 'restricted',
          label: t('artifacts.restricted', 'Restricted'),
        },
      ]}
    />
  )
}

StatusFilter.propTypes = {
  value: PropTypes.oneOf(['default', 'tombstoned', 'restricted', 'approved']).isRequired,
  onChange: PropTypes.func.isRequired,
}

export default StatusFilter
